export default {
 ADMIN: 'Admin',
 DRIVER: 'DRIVER',
 MANAGER: 'MANAGER',
 CUSTOMER: 'CUSTOMER',
 GUEST: 'GUEST'
};